import { useEffect, useLayoutEffect, useMemo } from "react";
import { _getURL } from "@/api/index";
import Redux, { updatePath } from "@/action";
import { _getBalances } from "@/libraries/fund";
import { useViewportSize } from "@mantine/hooks";
import Footer from "./footer";
import Header from "./header";
import { useRouter } from "next/router";
import { mobileViewWidth } from "../../config/site";

export default function NewLayout(props) {
    const { children } = props;
    const { t, session={} } = children.props;
    const { store, dispatch } = Redux();
    const { height, width } = useViewportSize();
    const router = useRouter();

    useEffect(() => {
        function updateSize() {
            if (window.innerWidth <= mobileViewWidth) {
                location.reload();
            }
        }
        window.addEventListener('resize', updateSize);

        const queryParams = new URLSearchParams(router.asPath.split('?')[1]);
        const isWebview = queryParams.get('isWebview');
        const isStandAlone = queryParams.get('isStandAlone');

        if(store?.path?.isLoadedInFlutterApp == undefined){
            dispatch(updatePath({ key: "isLoadedInFlutterApp", path: (isWebview == "true") ? true : false}));
        }
        if(store?.path?.isStandaloneInFlutterApp == undefined){
            dispatch(updatePath({ key: "isStandaloneInFlutterApp", path: (isStandAlone == "true") ? true : false}));
        }

        return () => window.removeEventListener('resize', updateSize);
    }, []);
    
    return <>
        <Header {...children.props} />
        {/* <!-- main start here --> */}
        
            {children}
                   
        {/* <!-- main ends here --> */}
        <Footer {...children.props}/>
    </>
}